import { render, staticRenderFns } from "./PunchTimelog.vue?vue&type=template&id=97a81696&scoped=true&lang=pug"
import script from "./PunchTimelog.vue?vue&type=script&lang=js"
export * from "./PunchTimelog.vue?vue&type=script&lang=js"
import style0 from "./PunchTimelog.vue?vue&type=style&index=0&id=97a81696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a81696",
  null
  
)

export default component.exports